import i18next from 'i18next';
import I18NextVue from 'i18next-vue';
import zhCN from '../i18n/zh-cn.json';
import enUS from '../i18n/en-us.json';
import { App } from 'vue';
import Cookies from 'js-cookie';

export const I18N_LOCALE_KEY = 'eecLocale';

const resources = {
  en: {
    translation: enUS,
  },
  zh: {
    translation: zhCN,
  },
};

export const i18n = i18next.createInstance({
  lng: 'zh',
  fallbackLng: 'zh',
  resources,
});

export const changeLng = async (lng: string) => {
  Cookies.set(I18N_LOCALE_KEY, lng, {
    expires: 365,
  });
  window.location.reload();
};

export const installI18n = async (app: App) => {
  // get init locale
  const validLocales = Object.keys(resources);
  const pageQuery = new URLSearchParams(location.search);

  const cookieLocale = Cookies.get(I18N_LOCALE_KEY);
  const queryLocale = (pageQuery.get('lng') as string) || '';
  const navLng = navigator.language.split('-')[0];

  const queue = [queryLocale, cookieLocale, navLng];

  for (const tmpLng of queue) {
    if (validLocales.includes(tmpLng)) {
      i18n.options.lng = tmpLng;
      break;
    }
  }

  if (queryLocale) {
    pageQuery.delete('lng');
    history.replaceState(
      null,
      '',
      `${location.pathname}?${pageQuery.toString()}${location.hash}`,
    );
  }

  Cookies.set(I18N_LOCALE_KEY, i18n.options.lng, {
    expires: 365,
  });

  await i18n.init();
  app.use(I18NextVue, { i18next: i18n });
};
